import { getCountries, getIPAndLocation, supplierCountries, mpSupplierCountries, hpLogisticCountries } from "@/api/dictionaryAPI";
import { createSlice, createAsyncThunk, createSelector } from "@reduxjs/toolkit";
import { filter, map } from "lodash";

export const fetchCountries = createAsyncThunk(
    'countries/fetchCountries',
    async (_, { getState }) => {
        const { countries } = getState();
        if (countries.list.length > 0) {
            // already have data → skip API
            return countries.list;
        }
        return await getCountries();
    }
);

export const getIPWithLocation = createAsyncThunk(
    "countries/getIPWithLocation",
    async () => {
        return await getIPAndLocation();
    }
);

export const fetchSupplierCountries = createAsyncThunk(
    "countries/fetchSupplierCountries",
    async (category) => {
        console.log("category ============== ", category);
        return await supplierCountries(category);
    }
);

export const fetchMPSupplierCountries = createAsyncThunk(
    "countries/fetchMPSupplierCountries",
    async () => {
        return await mpSupplierCountries();
    }
);


export const fetchHomePageLogisticCountries = createAsyncThunk(
    "countries/fetchHomePageLogisticCountries",
    async () => {
        const response = await hpLogisticCountries();

        console.log(
            "fetchHomePageLogisticCountries response:",
            response
        );

        return response;
    }
);



const countrySlice = createSlice({
    name: "countries",
    initialState: { list: [], ipAndCountry: [], loading: false, error: null, supplierCountryList: [], business_types: [], mpsupplierCountryList: [], mp_business_types: [], logisticCountryList: [] },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCountries.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCountries.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload
            })
            .addCase(fetchCountries.rejected, (state, action) => {
                state.loading = false;
                state.error = "Something Went Wrong!"
            })

            .addCase(getIPWithLocation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getIPWithLocation.fulfilled, (state, action) => {
                state.loading = false;
                state.ipAndCountry = action.payload;
            })
            .addCase(getIPWithLocation.rejected, (state, action) => {
                state.loading = false;
                state.ipAndCountry = [];
                state.error = action.error.message || "Something Went Wrong!";
            })

            .addCase(fetchSupplierCountries.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSupplierCountries.fulfilled, (state, action) => {
                state.loading = false;
                state.supplierCountryList = action.payload.countries;
                state.business_types = action.payload.shipment_mode;
            })
            .addCase(fetchSupplierCountries.rejected, (state, action) => {
                state.loading = false;
                state.error = "Something Went Wrong!"
            })

            .addCase(fetchMPSupplierCountries.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMPSupplierCountries.fulfilled, (state, action) => {
                state.loading = false;
                state.mpsupplierCountryList = action.payload.countries;
                state.mp_business_types = action.payload.shipment_mode;
            })
            .addCase(fetchMPSupplierCountries.rejected, (state, action) => {
                state.loading = false;
                state.error = "Something Went Wrong!"
            })
            builder
            .addCase(fetchHomePageLogisticCountries.pending, (state) => {
                state.loading = true;
                state.error = null;
                }
            )
            .addCase(fetchHomePageLogisticCountries.fulfilled,(state, action) => {
                state.loading = false;
                state.logisticCountryList = action.payload?.data?.countries || [];
                }
            )

            .addCase(fetchHomePageLogisticCountries.rejected, (state, action) => {
                state.loading = false;
                state.logisticCountryList = [];
                state.error = action.error?.message || "Something Went Wrong!";
                }
            );

            
    }
});

export const selectCountries = (state) => state.countries.list;

export const selectFormattedCountries = createSelector([selectCountries], (countries) => map(countries, (country, k) => {
    return {
        value: country.name,
        label: country.name,
        countryCode: country.iso2,
        countryId: country.id,
    }
}));



export const selectLogisticCountries = (state) => state.countries.logisticCountryList;
export const selectFormattedLogisticCountries = createSelector(
    [selectLogisticCountries],
    (countries) => {
        return map(countries || [], (country) => ({
            value: country.name,
            label: country.name,
            countryCode: country.iso2,
            countryId: country.id
        }));
    }
);


export const selectFormattedDemoCountriesList = createSelector([selectCountries], (countries) => map(countries, (country, k) => {
    return {
        value: country.name,
        label: country.name,
        countryCode: country.iso2,
        countryId: country.id,
        filter_flag: country.filter_flag
    }

}));

export const selectFormattedDemoCountries = createSelector([selectFormattedDemoCountriesList], (countries) => filter(countries, (c) => c.filter_flag === "1_Home_Search"));

export const selectSupplierCountries = (state) => state.countries.supplierCountryList;

export const selectSupplierTypes = (state) => state.countries.business_types;

export const mpselectSupplierCountries = (state) => state.countries.mpsupplierCountryList;

export const mpselectSupplierTypes = (state) => state.countries.mp_business_types;

export default countrySlice.reducer;

